
import {createCircleLayer} from "@/helpers/map.js"



export const circle = {
    state: {
        Circle: {
            "type": "FeatureCollection",
            "features": []
        },
        IS_DRAW_CIRCLE: false,
        DRAW_CIRCLE_MODE: false,
        DRAW_CIRCLE_RADIUS: 0
    },
    mutations: {
        SET_DRAWING_CIRCLE(state, payload) {
            state.IS_DRAW_CIRCLE = payload;
        },
        SET_DRAWING_CIRCLE_MODE(state, payload) {
            state.DRAW_CIRCLE_MODE = payload;
        },
        UPDATE_DRAWING_CIRCLE(state, payload) {
            let {radius} = payload;
            state.DRAW_CIRCLE_RADIUS = radius;
            state.Circle.features = createCircleLayer(payload);
        },
        CREATE_DRAWING_CIRCLE(state) {
            state.Circle.features = createCircleLayer()
        },
        SET_DRAWING_CIRCLE_RADIUS(state, radius) {
            state.DRAW_CIRCLE_RADIUS = radius;
            state.Circle.features[0].properties.radius = radius * 1000;
        }
    },
    getters: {
        isDrawCircle: state => state.IS_DRAW_CIRCLE,
        getDrawCircleMode: state => state.DRAW_CIRCLE_MODE,
        getDrawCircleRadius: state => state.DRAW_CIRCLE_RADIUS,
        getDrawCircleData: state => state.Circle

    },
    actions: {
        UPDATE_DRAWING_CIRCLE({commit, dispatch}, data) {
            commit('UPDATE_DRAWING_CIRCLE', data);
            dispatch('UPDATE_DRAWING_CIRCLE_RADIUS')
        },
        SET_DRAWING_CIRCLE_RADIUS({commit, dispatch}, radius) {
            commit('SET_DRAWING_CIRCLE_RADIUS', radius)
            dispatch('UPDATE_DRAWING_CIRCLE_RADIUS')
        },
        REMOVE_DRAWING_CIRCLE({commit, dispatch}) {
            commit('CREATE_DRAWING_CIRCLE');
            commit('SET_DRAWING_CIRCLE', false);
            commit('SET_DRAWING_CIRCLE_MODE', false);

            dispatch('UPDATE_DRAWING_CIRCLE_RADIUS');
        },
        UPDATE_DRAWING_CIRCLE_RADIUS({rootState, state}) {
            let map = rootState.map.map,
                Circle = state.Circle;
            map.getSource('DRAW_CIRCLE').setData(Circle)
        },

        async FETCH_DRAWING_CIRCLE_DATA({dispatch}, Circle) {
            try {
                Promise.all([
                    dispatch('fetchLocations', Circle),
                    dispatch('fetchAddresses', Circle)
                ])
            }catch(e) {
                console.log(e.response, 'hello world')
            }
        },
    }
}




